<ul class="myce-nav-dropdown" role="menu" (focusout)="onFocusout($event)">
  <li *ngFor="let item of items; trackBy: trackByLabel" role="none">
    <!-- Internal route link -->
    <a *ngIf="item.routeKey && !item.isExternal"
       [routerLink]="('/' + item.routeKey) | langLink"
       [queryParams]="item.queryParams || {}"
       class="myce-nav-dropdown__link"
       role="menuitem">
      <span class="english">{{ item.labelEn }}</span>
      <span class="spanish hidden">{{ item.labelEs }}</span>
    </a>
    <!-- External link -->
    <a *ngIf="item.isExternal"
       [href]="item.href"
       target="_blank"
       rel="noopener noreferrer"
       class="myce-nav-dropdown__link"
       role="menuitem">
      <span class="english">{{ item.labelEn }}</span>
      <span class="spanish hidden">{{ item.labelEs }}</span>
    </a>
  </li>
</ul>
